import { fetchLlmPolicy, selectLlmPoliciesByEnvId } from "@app/deploy";
import { useLoader, useSelector } from "@app/react";
import { useState } from "react";
import { ButtonAdmin } from "../button";
import { DetailHeader, DetailTitleBar } from "../detail-page-header-view";
import { IconEdit } from "../icons";
import { AllowedModelsList } from "./llm-policy-allowed-models";
import { LlmPolicyEditor } from "./llm-policy-editor";

export const LlmPolicyForEnvironment = ({
  envId,
  orgId,
}: { envId: string; orgId: string }) => {
  const {
    isLoading: isPolicyLoading,
    isInitialLoading: isPolicyInitialLoading,
  } = useLoader(fetchLlmPolicy);
  const policies = useSelector((s) => selectLlmPoliciesByEnvId(s, { envId }));
  const policy = policies.length > 0 ? policies[0] : null;
  const [isPolicyEditing, setIsPolicyEditing] = useState(false);

  return (
    <div className="mb-6">
      {isPolicyEditing ? (
        <LlmPolicyEditor
          envId={envId}
          orgId={orgId ?? ""}
          initialSpendLimit={policy?.spendLimit ?? null}
          initialModels={policy?.models ?? []}
          onClose={() => setIsPolicyEditing(false)}
        />
      ) : (
        <DetailHeader>
          <DetailTitleBar
            title="LLM Usage & Access Policy"
            isLoading={isPolicyLoading || isPolicyInitialLoading}
          />

          <AllowedModelsList
            policy={policy}
            isLoading={isPolicyLoading || isPolicyInitialLoading}
          />

          <hr className="my-2" />

          <div>
            <ButtonAdmin
              envId={envId}
              onClick={() => setIsPolicyEditing(true)}
              variant="white"
              type="button"
            >
              <IconEdit variant="sm" className="mr-2" />
              Edit Policy
            </ButtonAdmin>
          </div>
        </DetailHeader>
      )}
    </div>
  );
};
